import * as React from "react"
import { Link } from "gatsby"
import { StoreContext } from "../context/store-context"
import Logo from "../icons/logo"
import { Navigation } from "./navigation"
import { CartButton } from "./cart-button"
import SearchIcon from "../icons/search"
import { Toast } from "./toast"
import {
  header,
  container,
  logo as logoCss,
  searchButton,
  nav,
} from "./header.module.css"
import { styled } from "../styles/stitches.config";
import "@fontsource/benne";
import { IoMenuOutline, IoCartOutline } from 'react-icons/io5';

export function Header() {
  const { checkout, loading, didJustAddToCart } = React.useContext(StoreContext)

  const items = checkout ? checkout.lineItems : []

  const quantity = items.reduce((total, item) => {
    return total + item.quantity
  }, 0)

  const AnnouncementHeader = styled('div', {
    display: 'flex',
    color: 'white',
    width: '100%',
    backgroundColor: 'black',
    textAlign: 'center',
    fontSize: '10px',
    justifyContent: 'center',
    alignItems: 'center',
    letterSpacing: '4px',
    padding: '12px 40px',
  });

  const NewHeader = styled('div', {
    padding: '0px 40px 0px 40px',
    fontFamily: 'Benne',
    display: 'flex',
    height: '80px',
    width: '100%',
    justifyContent: 'space-between',
    alignItems: 'center',
    color: '#070e25',
    '@bp1': {
      fontSize: '20px !important',
      height: '72px',
      padding: '6px 20px 0px 20px',
    },
    '@bp2': {
      fontSize: '26px',
    },
    '& .badge': {
      fontFamily: '$lato',
      position: 'absolute',
      display: 'flex',
      color: 'white',
      backgroundColor: 'red',
      padding: '4px',
      fontSize: '10px',
      lineHeight: '10px',
      justifyContent: 'center',
      width: '20px',
      height: '20px',
      borderRadius: '100%',
      top: '60px',
      right: '32px',
      '@bp1': {
        top: '75px',
        right: '12px',
      },
    },
  });

  return (
    <div>
      <AnnouncementHeader>
        FREE SHIPPING TO SG/HK, REST OF WORLD $20. USE CODE BFF15 FOR 15% OFF BUNDLE ORDERS.
      </AnnouncementHeader>
      <NewHeader>
        <div>
          <span style={{ cursor: 'pointer' }} onClick={() => {
            document.getElementById('hi').style.transform = "translate(100vw, 0)";
            document.getElementById('background').style.display = "block";
            document.getElementsByTagName('body')[0].style.overflow = "hidden";
          }}><IoMenuOutline /></span>
        </div>
        <div style={{ paddingTop: '8px' }}>
          <span><Link to="/">Better Days Skin Co.</Link></span>
        </div>
        <div>
          <span>
            <Link to="/cart"><IoCartOutline />
              { quantity > 0 ? <span className="badge">{quantity}</span> : '' }
            </Link>
          </span>
        </div>
      </NewHeader>
      {/* <header className={header}>
        <Link to="/" className={logoCss}>
          <Logo />
        </Link>
        <Navigation className={nav} />
        <Link to="/search" className={searchButton}>
          <SearchIcon />
        </Link>
        <CartButton quantity={quantity} />
      </header> */}
      <Toast show={loading || didJustAddToCart}>
        {!didJustAddToCart ? (
          "Updating…"
        ) : (
          <>
            Added to cart{" "}
            <svg
              width="14"
              height="14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M5.019 10.492l-2.322-3.17A.796.796 0 013.91 6.304L6.628 9.14a1.056 1.056 0 11-1.61 1.351z"
                fill="#fff"
              />
              <path
                d="M5.209 10.693a1.11 1.11 0 01-.105-1.6l5.394-5.88a.757.757 0 011.159.973l-4.855 6.332a1.11 1.11 0 01-1.593.175z"
                fill="#fff"
              />
              <path
                d="M5.331 7.806c.272.326.471.543.815.163.345-.38-.108.96-.108.96l-1.123-.363.416-.76z"
                fill="#fff"
              />
            </svg>
          </>
        )}
      </Toast>
    </div>
  )
}
